import React, { useEffect, useState, useRef } from "react";
import abruzzo from "../../assets/Foto per transizione/P1088318.jpg";

const Sectionhome4 = () => {
  useEffect(() => {
    const elements = document.querySelectorAll(".moving-paragraph");

    if (elements.length > 0) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("visible");
            } /*  else {
                  entry.target.classList.remove("visible");
                } */
          });
        },
        {
          threshold: 0.3, // La visibilità minima dell'elemento per attivare la transizione
        }
      );

      elements.forEach((element) => observer.observe(element));

      return () => observer.disconnect();
    }
  }, []);
  return (
    <div
      id="luoghi"
      className="bg-[#191919] bg-opacity-60  flex flex-col md:flex-row-reverse items-center justify-center min-h-[60vh] p-16 text-white"
    >
      {/* Right Section - Text */}
      <div className="md:w-1/2 text-center md:text-left flex flex-col items-center md:ml-16 moving-paragraph">
        <h1 className="text-4xl md:text-5xl font-bold text-left text-white">
          Luoghi
        </h1>
        <h2 className="italic text-lg md:text-xl mt-2 text-left font-bold">
          Abruzzo
        </h2>
        <p className="mt-4 text-lg md:text-xl max-w-lg md:max-w-xl text-center">
          L'azienda si sviluppa nei Comuni montani della Valle Peligna, nel
          mezzo di Parchi e Riserve, dove la natura è protetta. <br /> Qui, la
          rigidità del clima invernale ha disegnato, nei secoli, la fisionomia
          del paesaggio. Gli uliveti sono confinati nelle zone pedemontane
          marginali, aspre e arroccate, ma risparmiate dalla discesa delle
          correnti fredde invernali.
          <br /> Il clima e i terreni difficili premiano la tenacia di chi
          coltiva con produzioni di qualità superiore.
        </p>
      </div>

      {/* Left Section - Single Image */}
      <div className="md:w-1/2 flex justify-center mt-6 md:mt-0 moving-paragraph">
        <div className="">
          <img
            src={abruzzo}
            alt="Piatto raffinato"
            className="w-full h-auto rounded-lg shadow-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default Sectionhome4;
